<template>
	<div class="p-col-12">
		<div class="p-col-12 p-grid">
			<div v-if="!commonService.isMobile()" class="p-col-1 p-lg-1 p-grid">
			</div>
			<div class="p-col-12 p-lg-10 p-grid" style="border-bottom: 1px solid grey;">
				<hr />
			</div>
			<div v-if="!commonService.isMobile()" class="p-col-1 p-lg-1 p-grid">
			</div>
		</div>

		<div class="p-col-12 p-grid">
			<div v-if="!commonService.isMobile()" class="p-col-2">
			</div>
			<div class="p-col-12 p-lg-1">
				<p style="font-size: x-large; font-weight: bold;">TiroLibre</p>
				<p style="margin-top: -10px;">{{new Date().getFullYear()}} © TiroLibre</p>
				<p style="margin-top: -10px;">All rights reserved.</p>
			</div>
			<div v-if="!commonService.isMobile()" class="p-col-1">
			</div>
			<div class="p-col-4 p-lg-1">
				<p style="font-size: medium; font-weight: bold;cursor: pointer" @click="toHome">Home</p>
				<!-- <p style="margin-top: -10px; font-size: medium; font-weight: bold;cursor: pointer" @click="commonService.openNewTab('')">Pricing</p> -->
				<p style="margin-top: -10px; font-size: medium; font-weight: bold;cursor: pointer" @click="aboutUs">About us</p>
				<!-- <p style="margin-top: -10px; font-size: medium; font-weight: bold;cursor: pointer" @click="commonService.openNewTab('')">Contact</p> -->
			</div>
			<div v-if="!commonService.isMobile()" class="p-col-1">
			</div>
			<div class="p-col-4 p-lg-1">
				<p style="font-size: medium; font-weight: bold;cursor: pointer" @click="commonService.openNewTab('https://www.facebook.com/Tiro.Libre16')">Facebook</p>
				<p style="margin-top: -10px; font-size: medium; font-weight: bold;cursor: pointer" @click="commonService.openNewTab('https://www.instagram.com/transfer.tirolibre.it')">Instagram</p>
				<p style="margin-top: -10px; font-size: medium; font-weight: bold;cursor: pointer" @click="commonService.openNewTab('https://www.linkedin.com/company/tirolibre/')">Linkedin</p>
			</div>
			<div v-if="!commonService.isMobile()" class="p-col-1">
			</div>
			<div class="p-col-4 p-lg-1">
				<p style="font-size: medium; font-weight: bold;cursor: pointer" @click="commonService.openNewTab('https://www.iubenda.com/privacy-policy/7839753')">Privacy Policy</p>
				<p style="margin-top: -10px;font-size: medium; font-weight: bold;cursor: pointer" @click="commonService.openNewTab('./assets/html/terms.html')">Terms & Conditions</p>
			</div>
			<div v-if="!commonService.isMobile()" class="p-col-2">
			</div>
		</div>
	</div>
</template>

<script>
import CommonService from "@/service/CommonService";

export default {
	commonService: null,
	created() {
		this.commonService = new CommonService();
	},
	methods: {
		aboutUs() {
			this.$router.push("/about");
		},
		toHome() {
			this.$router.push("/home");
		},
	},
};
</script>